import * as React from 'react';
import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

// ############################ Styles ###########################
// tslint:disable:variable-name

function radioColor(color: string, theme: OnlineThemeType) {
  switch (color) {
    case 'primary':
      return `
        background-color: ${theme.colors.primaryBright};
      `;
    case 'primaryLight':
    default:
      return `
        background-color: ${theme.colors.light3};
      `;
  }
}

function radioBorderColor(color: string, theme: OnlineThemeType) {
  switch (color) {
    case 'primary':
      return `
        border: 2px solid ${theme.colors.primaryBright};
      `;
    case 'primaryLight':
    default:
      return `
        border: 2px solid ${theme.colors.light3};
      `;
  }
}

function fontColor(color: string, theme: OnlineThemeType) {
  switch (color) {
    case 'primary':
      return `
        color: ${theme.colors.primaryBackground};
      `;
    case 'primaryLight':
    default:
      return `
        color: ${theme.colors.grayLight2}
      `;
  }
}

const SRadio = styled.label`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
`;

const SInputRadio = styled.input<{ color: string }>(
  ({ theme, color }) => `
  -webkit-appearance: none;
  width: 23px;
  min-width: 23px;
  height: 23px;
  border-radius: 50%;
  outline: none;
  border: 10px solid gray;
  cursor: pointer;
  margin-top: 0;
  ${radioBorderColor(color, theme)}
  &::before {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    margin: 4px auto;
    border-radius: 50%;
  }

  &:checked {
    &::before {
      ${radioColor(color, theme)}
    }
  }

  &:disabled {
    border-color: ${theme.colors.disabledButton};
    &:checked&::before {
      background-color: ${theme.colors.disabledButton};
    }
  }

  `
);

// tslint:disable-next-line:variable-name
// Bad behavior using color to change the font size be aware!
const SRadioLabel = styled.span<{ color: string }>(
  ({ theme, color }) => `
  margin-left: ${theme.spacing.medium}px;
  font-size: ${color === 'primary' ? '14px' : theme.font.size.smallMedium3};
  font-weight: ${color === 'primary' ? theme.font.weight.normal : theme.font.weight.light};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.18;
  letter-spacing: normal;
  text-align: left;
  ${fontColor(color, theme)};
  `
);
// tslint:enable:variable-name
// ############################ End Styles ###########################

export type RadioOnClick<T> = (value: T, e?: React.FormEvent<HTMLInputElement>) => void;

export interface IRadioOptionsProps<T> {
  label: React.ReactNode;
  value: T;
  dataAt?: string;
  disabled?: boolean;
  addToolTip?: string;
  className?: string;
  dataTestId?: string;
}

export interface IRadioProps<T> extends IRadioOptionsProps<T> {
  onClick: RadioOnClick<T>;
  onChange?: RadioOnClick<T>;
  color?: string;
  selected: boolean;
}

export class Radio<T> extends React.Component<IRadioProps<T>, null> {
  private handleClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(this.props.value, e);
    }
  };

  private handleChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(this.props.value, e);
    }
  };

  public render() {
    return (
      <SRadio className={this.props.className} data-at={this.props.dataAt}>
        <SInputRadio
          data-dd-action={`Radio Button - ${this.props.value}`}
          color={this.props.color}
          type="radio"
          onClick={this.handleClick}
          onChange={this.handleChange}
          value=""
          data-at={`value_${this.props.value}`}
          data-testid={this.props.dataTestId}
          checked={this.props.selected}
          disabled={this.props.disabled}
        />
        <SRadioLabel color={this.props.color}>{this.props.label}</SRadioLabel>
      </SRadio>
    );
  }
}

export default Radio;
